import React, { PropTypes } from 'react';
import { injectIntl, FormattedMessage, intlShape } from 'react-intl';
import { SAVED_SEARCH_WORKFLOW } from '../../../constants/WorkflowConstants';
import MessagingContainer from '../../../containers/shared/Messaging/MessagingContainer';
import FeatureFlagContainer from '../../../containers/FeatureFlagContainer';
import WorkflowContainer from '../../../containers/WorkflowContainer';
import SearchProbeContainer from '../../../containers/SearchProbeContainer';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { TextButton } from '@bibliocommons/base-buttons';
import { Generic } from '@bibliocommons/shared-messages';
import BroadenSearchLink from '../BroadenSearchLink';
import DidYouMean from '../DidYouMean';
import ExternalSearchLink from '../ExternalSearchLink';
import './SearchTitleDeprecated.scss';

class SearchTitleDeprecated extends BcReactComponent {

  renderSearchPaths() {
    const { broadened,
      broadenedSearchType,
      query,
      searchType } = this.props;

    return (
      <BroadenSearchLink
        query={query}
        searchType={searchType}
        broadenedSearchType={broadenedSearchType}
        isBroadened={broadened} />
    );
  }

  renderSearchTitle() {
    const { query, title, titleKey, searchType, intl, broadened } = this.props;
    const localizedSearchType = intl.formatMessage({
      id: `Search.searchTypes.${broadened ? 'bkw' : searchType}`
    });
    const localizedTitle = titleKey ? intl.formatMessage({ id: titleKey }) : null;
    return (
      <h1 key="titleForCurrentSearch" data-test-id="searchTitle" className="search-query">
        {title || localizedTitle || intl.formatMessage({ id: 'SearchTitle.typeResultsForQuery' }, { type: localizedSearchType, query })}
      </h1>
    );
  }

  renderSavedSearchLink(updateWorkflow) {
    if (!this.context.mobileApp) {
      return (
        <TextButton handleClick={() => updateWorkflow(SAVED_SEARCH_WORKFLOW)} className="save-search-link" data-test-id="save-search-link">
          {this.props.intl.formatMessage({ id: 'save_search' })}
        </TextButton>
      );
    }

    return null;
  }

  renderModifyLink() {
    const { customEdit, intl, query, searchType } = this.props;
    const searchUrl = `/search?custom_edit=${customEdit}&query=${encodeURIComponent(query)}`;

    if (searchType !== 'bl' || this.context.mobileApp) {
      return null;
    }

    return (
      <a href={searchUrl} className="modify-search-link" data-test-id="modify-search-link">
        {intl.formatMessage({ id: 'form_label_modify_my_search' })}
      </a>
    );
  }

  static renderMessaging({ message, clearMessages }) {
    if (message.get('type') === 'Success') {
      return (
        <Generic message={message} clearMessages={clearMessages} />
      );
    }
    return (
      <FormattedMessage
        id={message.get('id')}
        values={message.get('values')}
        tagName="h1" />
    );
  }

  render() {
    const { query,
            title,
            titleKey,
            suppress,
            searchType,
            didYouMeanQuerySuggestion,
            didYouMeanResultCount,
            handleDidYouMeanImpression,
            showExternalSearchLink } = this.props;
    return (
      <WorkflowContainer id={this.props.id}>
        {(workflowComponent, workflowActions) => workflowComponent || (
          <div className="row">
            <div className="col-xs-12 cp-search-title-deprecated" aria-atomic="true" data-test-id="search-title">
              <div className="search-term">
                <MessagingContainer id="searchTitle">
                  {SearchTitleDeprecated.renderMessaging}
                </MessagingContainer>
                {query || title || titleKey ? this.renderSearchTitle() : <noop />}
                <DidYouMean
                  key="did-you-mean"
                  handleDidYouMeanImpression={handleDidYouMeanImpression}
                  querySuggestion={didYouMeanQuerySuggestion}
                  resultCount={didYouMeanResultCount} />
              </div>
              <div className="search-tools">
                <FeatureFlagContainer>
                  {(flags) => flags.get('savedSearch') ? this.renderSavedSearchLink(workflowActions.updateWorkflow) : null}
                </FeatureFlagContainer>
                {showExternalSearchLink ? <ExternalSearchLink query={query} searchType={searchType} /> : null}
                {!suppress && query ? this.renderSearchPaths() : null}
                { this.renderModifyLink() }
                <SearchProbeContainer />
              </div>
            </div>
          </div>
        )}
      </WorkflowContainer>
    );
  }
}

SearchTitleDeprecated.propTypes = {
  title: PropTypes.string,
  titleKey: PropTypes.string,
  customEdit: PropTypes.bool,
  suppress: PropTypes.bool,
  intl: intlShape,
  searchType: PropTypes.string,
  query: PropTypes.string,
  broadenedSearchType: PropTypes.string,
  broadenedSearchCount: PropTypes.number,
  broadened: PropTypes.bool,
  didYouMeanResultCount: PropTypes.number,
  didYouMeanQuerySuggestion: PropTypes.string,
  showExternalSearchLink: React.PropTypes.bool
};

SearchTitleDeprecated.contextTypes = {
  mobileApp: PropTypes.bool
};

export default injectIntl(SearchTitleDeprecated);



// WEBPACK FOOTER //
// ./app/components/search/SearchTitleDeprecated/SearchTitleDeprecated.jsx